import { useState } from "react";
import LogoAdoraTeam from "./LogoAdoraTeam";
import { PLANOS_CONFIG, ORDEM_PLANOS } from "../constants/planos";

const GOLD = "#F9A826";
const BLUE = "#0f1729";
const API = process.env.REACT_APP_API_URL || "http://localhost:3000";

function token() { return localStorage.getItem("adorateam_token"); }

export default function EscolherPlano({ usuario, onConcluir, modoUpgrade = false, grupoAtual = null }) {
    const [planoSel, setPlanoSel] = useState(modoUpgrade ? "pro" : "starter");
    const [carregando, setCarregando] = useState(false);
    const [etapa, setEtapa] = useState("escolher"); // "escolher" | "pagamento" | "confirmando"
    const [erro, setErro] = useState("");

    const planoAtualId = grupoAtual?.plano || "starter";
    const planoAtualIdx = ORDEM_PLANOS.indexOf(planoAtualId);

    // No modo upgrade, mostrar só planos acima do atual
    const planosVisiveis = modoUpgrade
        ? ORDEM_PLANOS.filter(id => ORDEM_PLANOS.indexOf(id) > planoAtualIdx).map(id => PLANOS_CONFIG[id])
        : ORDEM_PLANOS.map(id => PLANOS_CONFIG[id]);

    const planoObj = PLANOS_CONFIG[planoSel];
    const isPago = planoObj?.preco > 0;

    const confirmar = async () => {
        setCarregando(true);
        setErro("");
        try {
            if (!isPago) {
                // Starter: apenas salvar
                const res = await fetch(`${API}/api/auth/atualizar-plano`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
                    body: JSON.stringify({ plano: planoSel }),
                });
                const data = await res.json();
                if (!res.ok) throw new Error(data.erro || "Erro");
                onConcluir({ ...usuario, plano: planoSel });
            } else {
                // Pago: criar preferência Mercado Pago
                setEtapa("confirmando");
                const res = await fetch(`${API}/api/pagamentos/criar-assinatura`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
                    body: JSON.stringify({ plano: planoSel }),
                });
                const data = await res.json();
                if (!res.ok) throw new Error(data.erro || "Erro ao iniciar pagamento");
                // Redireciona para o Checkout Pro do Mercado Pago
                if (data.init_point) {
                    window.location.href = data.init_point;
                } else {
                    throw new Error("Link de pagamento não gerado");
                }
            }
        } catch (e) {
            setErro(e.message);
            setEtapa("escolher");
        } finally {
            setCarregando(false);
        }
    };

    // ── Tela confirmando pagamento ──
    if (etapa === "confirmando") {
        return (
            <div style={{ minHeight: "100vh", background: BLUE, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 24 }}>
                <div style={{ fontSize: 48, marginBottom: 16 }}>⏳</div>
                <div style={{ fontSize: 20, fontWeight: 800, color: "white", marginBottom: 8 }}>Redirecionando...</div>
                <div style={{ fontSize: 14, color: "#8899bb", textAlign: "center" }}>
                    Você será direcionado ao Mercado Pago para finalizar o pagamento com segurança.
                </div>
            </div>
        );
    }

    return (
        <div style={{
            minHeight: "100vh", background: BLUE,
            display: "flex", flexDirection: "column",
            alignItems: "center", padding: "32px 16px 120px",
            boxSizing: "border-box"
        }}>
            <style>{`
                @keyframes fadeUp { from { opacity:0; transform:translateY(16px); } to { opacity:1; transform:translateY(0); } }
                @keyframes pulse { 0%,100%{transform:scale(1)} 50%{transform:scale(1.03)} }
            `}</style>

            {/* Header */}
            <div style={{ animation: "fadeUp 0.4s ease both", textAlign: "center", marginBottom: 28 }}>
                <LogoAdoraTeam size={48} glow={true} />
                <div style={{ marginTop: 12, fontSize: 22, fontWeight: 800, color: "white" }}>
                    {modoUpgrade ? "Fazer upgrade" : "Escolha seu plano"}
                </div>
                <div style={{ fontSize: 13, color: "#8899bb", marginTop: 4 }}>
                    {modoUpgrade
                        ? `Plano atual: ${PLANOS_CONFIG[planoAtualId]?.nome}. Escolha um plano superior.`
                        : `Olá, `}{!modoUpgrade && <strong style={{ color: GOLD }}>{usuario?.nome?.split(" ")[0]}</strong>}
                    {!modoUpgrade && "! Selecione o melhor plano para seu ministério."}
                </div>
            </div>

            {/* Cards de planos */}
            <div style={{ width: "100%", maxWidth: 420, display: "flex", flexDirection: "column", gap: 14 }}>
                {planosVisiveis.map((p, i) => {
                    const selecionado = planoSel === p.id;
                    const isBloqueado = modoUpgrade && ORDEM_PLANOS.indexOf(p.id) <= planoAtualIdx;
                    return (
                        <button
                            key={p.id}
                            onClick={() => !isBloqueado && setPlanoSel(p.id)}
                            style={{
                                animation: `fadeUp 0.4s ${0.1 + i * 0.08}s ease both`,
                                background: selecionado ? `${p.cor}18` : "#162040",
                                border: `2px solid ${selecionado ? p.cor : "#2a3a5e"}`,
                                borderRadius: 20, padding: "18px 20px",
                                cursor: isBloqueado ? "not-allowed" : "pointer",
                                textAlign: "left", transition: "all 0.2s",
                                position: "relative", opacity: isBloqueado ? 0.5 : 1,
                                boxShadow: selecionado ? `0 4px 24px ${p.cor}33` : "none",
                            }}
                        >
                            {p.destaque && (
                                <div style={{
                                    position: "absolute", top: -12, left: "50%",
                                    transform: "translateX(-50%)",
                                    background: `linear-gradient(135deg, ${GOLD}, #FFD166)`,
                                    borderRadius: 20, padding: "3px 14px",
                                    fontSize: 11, fontWeight: 800, color: BLUE,
                                    animation: "pulse 2s ease-in-out infinite"
                                }}>⭐ MAIS POPULAR</div>
                            )}

                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                    <div style={{
                                        width: 44, height: 44, borderRadius: 12,
                                        background: `${p.cor}22`,
                                        display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22
                                    }}>{p.emoji}</div>
                                    <div>
                                        <div style={{ fontSize: 17, fontWeight: 800, color: selecionado ? p.cor : "white" }}>{p.nome}</div>
                                        <div style={{ fontSize: 11, color: "#8899bb" }}>
                                            {p.maxMembros >= 999999 ? "Membros ilimitados" : `Até ${p.maxMembros} membros`}
                                        </div>
                                    </div>
                                </div>
                                <div style={{ textAlign: "right" }}>
                                    <div style={{ fontSize: 20, fontWeight: 900, color: selecionado ? p.cor : "white" }}>
                                        {p.precoFormatado}
                                    </div>
                                    <div style={{ fontSize: 11, color: "#8899bb" }}>{p.periodo}</div>
                                </div>
                            </div>

                            <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                                {p.recursos.map((r, j) => (
                                    <div key={j} style={{ fontSize: 13, color: "#b0bcd4" }}>{r}</div>
                                ))}
                            </div>

                            {p.preco > 0 && (
                                <div style={{
                                    marginTop: 12, padding: "8px 10px",
                                    background: `${p.cor}12`, borderRadius: 10,
                                    border: `1px solid ${p.cor}30`,
                                    fontSize: 12, color: p.cor, fontWeight: 600
                                }}>
                                    🔒 30 dias grátis · Cancele quando quiser
                                </div>
                            )}

                            {selecionado && (
                                <div style={{
                                    marginTop: 10, padding: "6px 0",
                                    borderTop: `1px solid ${p.cor}33`,
                                    display: "flex", alignItems: "center", gap: 6
                                }}>
                                    <div style={{
                                        width: 18, height: 18, borderRadius: "50%",
                                        background: p.cor, display: "flex", alignItems: "center",
                                        justifyContent: "center", fontSize: 11, color: BLUE, fontWeight: 900
                                    }}>✓</div>
                                    <span style={{ fontSize: 12, color: p.cor, fontWeight: 700 }}>Plano selecionado</span>
                                </div>
                            )}
                        </button>
                    );
                })}
            </div>

            {/* Rodapé fixo */}
            <div style={{
                position: "fixed", bottom: 0, left: 0, right: 0,
                background: "#111e35", borderTop: "1px solid #2a3a5e",
                padding: "14px 20px 20px",
                display: "flex", flexDirection: "column", alignItems: "center", gap: 8
            }}>
                {erro && (
                    <div style={{ fontSize: 12, color: "#ff6b6b", background: "#ff6b6b15", borderRadius: 8, padding: "6px 14px", width: "100%", maxWidth: 420, textAlign: "center" }}>
                        ⚠️ {erro}
                    </div>
                )}
                <div style={{ fontSize: 12, color: "#8899bb" }}>
                    {!isPago
                        ? "Comece grátis, faça upgrade quando quiser"
                        : `30 dias grátis, depois ${planoObj.precoFormatado}/mês`}
                </div>
                <button onClick={confirmar} disabled={carregando} style={{
                    width: "100%", maxWidth: 420, padding: 15, borderRadius: 14,
                    background: carregando ? "#2a3a5e" : `linear-gradient(135deg, ${planoObj?.cor || GOLD}, ${planoObj?.cor || GOLD}bb)`,
                    border: "none", color: BLUE, fontWeight: 800, fontSize: 16,
                    cursor: carregando ? "default" : "pointer",
                    boxShadow: `0 4px 20px ${planoObj?.cor || GOLD}44`
                }}>
                    {carregando
                        ? "Aguarde..."
                        : isPago
                            ? `Iniciar trial grátis — Plano ${planoObj.nome} →`
                            : "Começar grátis →"}
                </button>
                {isPago && (
                    <div style={{ fontSize: 11, color: "#4a5a7e" }}>
                        🔒 Pagamento seguro via Mercado Pago · Cancele a qualquer momento
                    </div>
                )}
                {modoUpgrade && (
                    <button onClick={() => onConcluir(null)} style={{
                        background: "none", border: "none", color: "#4a5a7e",
                        fontSize: 12, cursor: "pointer", padding: "4px 0"
                    }}>Continuar com plano atual</button>
                )}
            </div>
        </div>
    );
}